// DEC-023 (Amended 2026-05-15) / DEC-037 (Phase 33 board-view enum rename) — the
// 6×6 board has two interchangeable views (Chess + Letters). The player toggles
// between them so chess pieces and letter cubes are never stacked simultaneously.
//
// This type is the single source of truth threaded from MatchScreen down
// through MatchCanvas → GameCanvas → World → BoardLayer/LetterLayer/PieceLayer.

export type BoardView = 'chess' | 'letters'

export const DEFAULT_BOARD_VIEW: BoardView = 'letters'
